import { createContext } from 'react';
import { ProgramSummaryCardIcon } from 'spw-redux/modules/projects/types';

export const ProgrammingSummaryCardsContext = createContext<{
  onClickCardIcon?: (
    event: React.MouseEvent<HTMLDivElement>,
    cardIcon: ProgramSummaryCardIcon
  ) => void;
  selectedCardIcon?: ProgramSummaryCardIcon;
  showRsf: boolean;
  setShowRsf: (rsf: boolean) => void;
}>({
  onClickCardIcon: null,
  selectedCardIcon: null,
  showRsf: false,
  setShowRsf: null,
});
